import { StockDetailsContent } from '../../../constants/Constants';

export const ALL = StockDetailsContent.allOptionValue;

// Shared dropdown styling
export const selectMenuProps = {
  PaperProps: {
    sx: {
      maxHeight: 320,
      mt: 0.5,
      '& .MuiMenuItem-root': {
        minHeight: 40,
        paddingTop: 1,
        paddingBottom: 1,
        fontSize: 12,
      },
    },
  },
};

export const searchableFilterSx = {
  width: '100%',
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#E2E8F0',
  },
};

export type SearchableOption = {
  value: string;
  label: string;
};

export const EMPTY_CARRIER_OPTION: SearchableOption = {
  value: '',
  label: '',
};
